/*!
 * v-uppercase
 */

const index = {
  /*
  * install function
  * @param  {Vue} Vue
  */
  install(Vue) {
    Vue.directive('uppercase', {
      update(state) {
        state.value = state.value.toUpperCase();
      },
    });
  },
};

export default index;
